// extracted by mini-css-extract-plugin
export default {"tooltip":"lp-z","sharingV2":"mp-z","sharingIconsV2":"np-z","links":"op-z","link":"pp-z","facebookV2":"qp-z","twitterV2":"rp-z","pinterestV2":"sp-z"};